export default {
  title: 'dark',
  colors: {
    mainColorLighter: '#88F2CC',
    mainColor: '#4CA585',
    mainColorDarker: '#205945',

    black: '#131615',
    greyDarker: '#38423F',
    grey02: '#5E6E68',
    grey03: '#869891',
    grey04: '#B2BDB9',
    greyLighter: '#DEE3E1',
    whiteDarker: '#F4F6F5',
    white: '#FFFFFF',

    warning: '#FFBA57',
    warningLighter: '#FFF1DD',
    success: '#41C19F',
    successLighter: '#D1E8E2',
    info: '#00ACC1',
    infoLighter: '#CCEEF3',
    dange: '#FF526A',
    dangeLigther: '#FFE6E9',
  }
}
